module.exports = __webpack_public_path__ + "img/027-panda bear.1a885119.svg";